import { useState, useCallback, useRef } from 'react';
import { docsApi, type DocIndex } from '@/services/docsApi';

export function useDocSearch() {
  const [results, setResults] = useState<DocIndex[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const search = useCallback((query: string, filters?: { repo?: string; type?: string; project?: string }) => {
    if (timerRef.current) clearTimeout(timerRef.current);

    if (!query.trim()) {
      setResults([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    setLoading(true);
    timerRef.current = setTimeout(async () => {
      try {
        const data = await docsApi.searchDocs({ q: query, ...filters });
        setResults(data.items);
        setTotal(data.total);
      } catch {
        setResults([]);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    }, 300);
  }, []);

  return { results, total, loading, search };
}
